var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"img-wrapper"},_vm._l((_vm.imgs),function(img,index){return _c('img',{key:index,staticClass:"add-img",attrs:{"src":_vm.imgs[index]}})}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a84bd76","hasScoped":true,"transformToRequire":{"video":["app","poster"],"source":"app","img":"app","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/pages/tabs/ScoreShop/GoodsUrlPage.vue
// module id = null
// module chunks = 